import React from "react";

const awards = [
    {
    title: "⭐ Simplifier Award",
    year: "2026",
    detail: "Awarded for simplifying complex technical challenges through scalable architecture and innovative engineering solutions.",
  },
  {
    title: "🏆 Best Mentor Award",
    year: "2025",
    detail: "Recognized for mentoring junior engineers, improving code quality, and fostering a collaborative engineering culture.",
  },
  {
    title: "🚀 React Native Product Launch",
    year: "2024",
    detail: "Successfully led the development and deployment of production-ready React Native applications for Android and iOS from concept to release.",
  },
  {
    title: "👨‍💻 Technical Leadership",
    year: "2023",
    detail: "Mentored a team of 6 engineers, established frontend development standards, and promoted engineering best practices.",
  },
];

function AwardsSection() {
  return (
    <section className="awards-section">
      <div className="section-shell awards-shell">
        <div className="section-heading awards-heading">
          <span className="eyebrow">Certificates & Awards</span>
          <h2>Milestones that shaped the journey.</h2>
        </div>

        <div className="awards-grid">
          {awards.map((award, index) => (
            <article className="award-card" key={`${award.title}-${award.year}`}>
              <div className="award-number">0{index + 1}</div>
              <div className="award-copy">
                <span className="award-year">{award.year}</span>
                <h3>{award.title}</h3>
                <p>{award.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AwardsSection;
